import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiService } from "../../services/apiService";
import { useCarContext } from "../CarContext";
import { Button, ImageWithFallback } from "../components/Utilities";
import call from "../assets/call.svg";
import smallcar from "../assets/smallcar.svg";
import dummyImg from "../assets/dummyImg.svg";
import { CarCard } from "./CarCard";
import locCard from "../assets/locCard.svg";
import { GatePassModal } from "../components/ModelOverlay/RequestGatepass";
import { AddEvaluatorModal } from "../components/ModelOverlay/AddEmulator";
import "./Inspection.css";
import { ToastContainer, toast } from "react-toastify";
import { Loading } from "../components/Loading";
import { formatOwnership } from "../DealerHome";


// ---- ADD THIS FUNCTION (once) ----
export const buildCleanMapIframe = (iframeHtml) => {
  if (!iframeHtml) return null;

  // Extract src=""
  const srcMatch = iframeHtml.match(/src=["']([^"']+)["']/);
  if (!srcMatch) return iframeHtml;

  const src = srcMatch[1];
  const pbMatch = src.match(/pb=([^&"]+)/);
  if (!pbMatch) return iframeHtml;

  const pb = pbMatch[1];
  const cleanSrc = `https://www.google.com/maps/embed?pb=${pb}&hl=en&output=embed&z=15&maptype=roadmap`;

  return `<iframe src="${cleanSrc}"width="100%" style="border:none;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;
};

// Utility function to format time left
export const formatTimeLeft = (taEndDateStr) => {
  if (!taEndDateStr || typeof taEndDateStr !== "string") {
    console.warn("Invalid ta_end_date:", taEndDateStr);
    return "N/A";
  }
  const endDate = new Date(taEndDateStr);
  if (isNaN(endDate.getTime())) {
    console.warn("Invalid date format for ta_end_date:", taEndDateStr);
    return "N/A";
  }
  const now = new Date();
  const diffMs = endDate - now;

  if (diffMs <= 0) {
    return "Expired";
  }

  const diffSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(diffSeconds / (3600 * 24));
  const hours = Math.floor((diffSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((diffSeconds % 3600) / 60);
  const seconds = diffSeconds % 60;

  if (days > 0) {
    return `${days}D:${hours.toString().padStart(2, "0")}H`;
  } else if (hours > 0) {
    return `${hours}H:${minutes.toString().padStart(2, "0")}M`;
  } else if (minutes > 0) {
    return `${minutes}M:${seconds.toString().padStart(2, "0")}S`;
  } else {
    return `${seconds}S`;
  }
};
 export const getMapUrl = (iframeHtml) => {
    if (!iframeHtml) return "https://maps.google.com";
    const match = iframeHtml.match(/src=["']([^"']+)["']/);
    return match ? match[1] : "https://maps.google.com";
  };
// Location Card Component — now accepts yardMap (iframe HTML string)
const LocationCard = ({
  yard,
  yardCars,
  onRequestGatePass,
  onClickToCall,
  carCount,
  isPendingGroup = false,
  isApprovedGroup = false,
  onShareEvaluationLink,
  isActionLoading = false,
  isShared = false,
  yardMap = null, // Dynamic map iframe HTML
}) => {
  const yardLocation = yardCars[0]?.location || yard || "Select a Car";
  // Extract src URL from iframe HTML string

  return (
    <div className="car-card location-card">
      <div className="location-column">
        <div className="car-count-heading">
          <ImageWithFallback
            src={smallcar}
            alt="Car Icon"
            className="small-car-icon"
          />
          <span className="car-count"> {carCount}</span>
        </div>
        <div className="location-heading">
          <img src={locCard} alt="Location" className="location-img" />
          <p className="location-title">{yardLocation}</p>
        </div>

        {/* Dynamic Google Map iframe */}
        {/* Dynamic Google Map iframe with clickable overlay */}
        <div
          className="container-map"
          onClick={() => window.open(getMapUrl(yardMap), "_blank")}
        >
          <div
            className="yard-map-container"
            dangerouslySetInnerHTML={{
              __html:
                buildCleanMapIframe(yardMap) ||
                '<div style="background:#f0f0f0; height:200px; display:flex; align-items:center; justify-content:center; color:#999; font-size:14px;">Map not available</div>',
            }}
          />
        </div>

        <div className="car-actions-location">
          {isPendingGroup ? (
            <Button className="btn-full-pending" variant="primary" disabled>
              Pending Gate Pass
            </Button>
          ) : isApprovedGroup ? (
            <Button
              className="btn-full"
              variant="primary"
              onClick={onShareEvaluationLink}
              disabled={isActionLoading || isShared}
            >
              {isActionLoading ? "Sharing..." : "Share Evaluation Link"}
            </Button>
          ) : (
            <Button
              className="btn-full"
              variant="primary"
              onClick={onRequestGatePass}
              disabled={isActionLoading}
            >
              {isActionLoading ? "Requesting..." : "Request Gate Pass"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default function Inspection() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { setCarCount, setUploadPicturesCount } = useCarContext();
  const [isGatePassModalOpen, setIsGatePassModalOpen] = useState(false);
  const [isAddEvaluatorModalOpen, setIsAddEvaluatorModalOpen] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [selectedYard, setSelectedYard] = useState(null);
  const [localMyCars, setLocalMyCars] = useState([]);
  const [yardMapData, setYardMapData] = useState({}); // NEW: Store YardMap per yard
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState(null);
  const [driverAdded, setDriverAdded] = useState(false);
  const [shareError, setShareError] = useState(null);
  const carGridRefs = useRef({});
  const [otpAccessForm, setOtpAccessForm] = useState({
    phoneNumber: "",
    userName: "",
    userRole: "dealer_evalator",
    orgId: "trustauto",
    validityDays: 1,
    validityMinutes: 0,
    purpose: "Testing OTP Login",
    description: "Test access for OTP login functionality",
    landingPage: "/evaluatorHome",
  });
  const [sharedYards, setSharedYards] = useState([]);

  // Format owner
  const formatOwner = (ownership) => {
    if (!ownership) return "1st owner";
    return `${ownership}${
      ownership === 1
        ? "st owner"
        : ownership === 2
        ? "nd owner"
        : ownership === 3
        ? "rd owner"
        : "th owner"
    }`;
  };

  // Handle navigated car from state
  useEffect(() => {
    if (state?.car) {
      const navigatedCar = {
        id:
          state.car.car_id || `car-${Math.random().toString(36).substr(2, 9)}`,
        car_id: state.car.car_id,
        brand: state.car.make || "Unknown",
        model: state.car.model || "Unknown",
        rto: state.car.regno || "N/A",
        fuel: state.car.fueltype || "Unknown",
        transmission: state.car.transmission || "N/A",
        year: Number(state.car.year) || 0,
        km: Number(state.car.kmsrun) || 0,
        image:
          state.car.car_image_urls && state.car.car_image_urls.length > 0
            ? state.car.car_image_urls[0]
            : state.car.logoUrl ||
              "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+SW1hZ2U8L3RleHQ+PC9zdmc+",
        timeLeft: state.car.ta_end_date
          ? formatTimeLeft(state.car.ta_end_date)
          : "N/A",
        location: state.car.yard || "Unknown",
        rc:
          state.car.rcstatus?.toUpperCase() === "YES" ||
          state.car.rcstatus?.toUpperCase() === "Y" ||
          state.car.rcstatus?.toUpperCase() === "AVAILABLE",
        driverId: state.car.driverId,
        owner: formatOwner(state.car.ownership),
        yard: state.car.yard || "Unknown Yard",
        auctionId: state.car.auctionId || "Mho2gABuWpALytpRoIwJ",
        state: state.car.state || "MY_CARS_NEW",
      };
      setLocalMyCars((prev) => {
        if (prev.some((car) => car.id === navigatedCar.id)) return prev;
        const updatedCars = [...prev, navigatedCar];
        setCarCount(updatedCars.length);
        return updatedCars;
      });
      setSelectedCar(navigatedCar);
    }
  }, [state, setCarCount]);

  // Fetch cars + extract YardMap
  useEffect(() => {
    const fetchMyCars = async () => {
      try {
        setLoading(true);
        const response = await apiService.getMyCarsByYard({});
        const groupedCars = response.data || {};

        // Extract YardMap for each yard
        const extractedYardMaps = {};
        Object.entries(groupedCars).forEach(([yard, data]) => {
          if (data.YardMap) {
            extractedYardMaps[yard] = data.YardMap;
          }
        });
        setYardMapData(extractedYardMaps);

        const validCars = Object.entries(groupedCars).flatMap(([yard, data]) =>
          (data.cars || []).map((car) => ({
            id: car.car_id || `car-${Math.random().toString(36).substr(2, 9)}`,
            car_id: car.car_id,
            brand: car.make || "Unknown",
            model: car.model || "Unknown",
            rto: car.regno || "N/A",
            fuel: car.fueltype || "Unknown",
            transmission: car.transmission || "N/A",
            driverId: car.driverId,
            year: Number(car.year) || 0,
            km: Number(car.kmsrun) || 0,
            startDate: car["start-date"],
            endDate: car["ta-end-date"] || car["ta_end_date"],
            image:
              car.car_image_urls && car.car_image_urls.length > 0
                ? car.car_image_urls[0]
                : car.logoUrl ||
                  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+SW1hZ2U8L3RleHQ+PC9zdmc+",
            timeLeft: car.ta_end_date ? formatTimeLeft(car.ta_end_date) : "N/A",
            location: car.yard || "Unknown",
            rc:
              car.rcstatus?.toUpperCase() === "YES" ||
              car.rcstatus?.toUpperCase() === "Y" ||
              car.rcstatus?.toUpperCase() === "AVAILABLE",
            owner: formatOwner(car.ownership),
            yard: car.yard || "Unknown Yard",
            auctionId: car.auctionId || "Mho2gABuWpALytpRoIwJ",
            state: car.state || "MY_CARS_NEW",
            isSold: car.isSold,
          }))
        );

        setLocalMyCars(validCars);
        setCarCount(validCars.length);
        setSelectedCar((prev) => prev || validCars[0] || null);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching cars:", err);
        setError("Failed to load cars. Please try again.");
        setLocalMyCars([]);
        setCarCount(0);
        setSelectedCar(null);
        setLoading(false);
      }
    };
    fetchMyCars();
  }, [setCarCount]);

  // Group cars
  const groupedNew = localMyCars
    .filter(
      (car) =>
        car.state !== "GATE_PASS_REQUESTED" &&
        car.state !== "GATE_PASS_APPROVED"
    )
    .reduce((acc, car) => {
      const yard = car.yard || "Unknown Yard";
      acc[yard] = acc[yard] || [];
      acc[yard].push(car);
      return acc;
    }, {});

  const groupedRequested = localMyCars
    .filter((car) => car.state === "GATE_PASS_REQUESTED")
    .reduce((acc, car) => {
      const yard = car.yard || "Unknown Yard";
      acc[yard] = acc[yard] || [];
      acc[yard].push(car);
      return acc;
    }, {});

  const groupedApproved = localMyCars
    .filter((car) => car.state === "GATE_PASS_APPROVED")
    .reduce((acc, car) => {
      const yard = car.yard || "Unknown Yard";
      acc[yard] = acc[yard] || [];
      acc[yard].push(car);
      return acc;
    }, {});

  const handleCarAuctionClick = () => {
    navigate("/DealerHome");
  };

  const handleTenderClick = () => {
    navigate("/tender");
  };

  const handleRequestGatePass = async (yard) => {
    setActionLoading(true);
    try {
      setSelectedYard(yard);
      setIsGatePassModalOpen(true);
    } finally {
      setActionLoading(false);
    }
  };

  const handleChooseEvaluator = () => {};

  const handleAddEvaluator = () => {
    setIsAddEvaluatorModalOpen(true);
  };

  const handleCarSelect = (car) => {
    if (!car.isDummy && !car.isLocationCard) {
      setSelectedCar(car);
      navigate(`/car-details/${car.id}`);
    }
  };

  const handleCloseGatePassModal = () => {
    setIsGatePassModalOpen(false);
    setSelectedYard(null);
  };

  const handleCloseAddEvaluatorModal = () => {
    setIsAddEvaluatorModalOpen(false);
  };

  const handleDriverAdded = () => {
    setDriverAdded(!driverAdded);
    handleCloseAddEvaluatorModal();
  };

  const handleClickToCall = () => {
    console.log("Click to Call initiated");
  };

  const handleShareEvaluationLink = async (yardCars, yard) => {
    setActionLoading(true);
    setShareError(null);

    try {
      const carIds = yardCars
        .filter((car) => car.car_id)
        .map((car) => car.car_id);
      if (carIds.length === 0) {
        toast.error("No valid cars to share evaluation link.");
        return;
      }

      const basurl = window.location.origin;

      const driverResponse = await apiService.getDrivers("evaluator");
      for (const car of yardCars) {
        if (car.driverId) {
          const matchedDriver = driverResponse.data.find(
            (d) => d.id === car.driverId
          );
          if (matchedDriver) {
            const carOtpForm = {
              ...otpAccessForm,
              userName: matchedDriver.name,
              phoneNumber: matchedDriver.phone,
              baseurl: basurl,
            };
            await apiService.createOTPLoginAccess(carOtpForm);
          }
        }
      }

      setOtpAccessForm((prev) => ({ ...prev, userName: "", phoneNumber: "" }));

      const response = await apiService.shareEvalLink(carIds);
      if (response.status === 200) {
        const evalLink = response.data?.link || "Link shared";
        setSharedYards((prev) => {
          if (!prev.includes(yard)) {
            return [...prev, yard];
          }
          return prev;
        });
        toast.success(`Evaluation link: ${evalLink}`, {
          onClose: () => {
            const carIdsToMove = yardCars.map((car) => car.id);
            setLocalMyCars((prev) => {
              const updated = prev.filter(
                (car) => !carIdsToMove.includes(car.id)
              );
              setCarCount(updated.length);
              setUploadPicturesCount((prev) => prev + carIdsToMove.length);
              return updated;
            });
          },
        });
      }
    } catch (err) {
      const msg =
        err.response?.data?.error || err.message || "Failed to share link";
      setShareError(msg);
      toast.error(msg);
    } finally {
      setActionLoading(false);
    }
  };

  const handleRemove = async (carId) => {
    setActionLoading(true);
    try {
      await apiService.removeFromMyCars({ carId });
      setLocalMyCars((prev) => {
        const updated = prev.filter((car) => car.id !== carId);
        setCarCount(updated.length);
        return updated;
      });
      setSelectedCar((prev) => (prev?.id === carId ? null : prev));
    } catch (err) {
      toast.error("Failed to remove car.");
    } finally {
      setActionLoading(false);
    }
  };

  const handleGatePassCreated = (carIds) => {
    setLocalMyCars((prev) =>
      prev.map((car) =>
        carIds.includes(car.id) ? { ...car, state: "GATE_PASS_REQUESTED" } : car
      )
    );
  };

  const handleSeeMoreCars = () => {
    navigate("/DealerHome");
  };

  const handleSlideRight = (groupKey, viewType = "web") => {
    const refKey = `${viewType}-${groupKey}`;
    const ref = carGridRefs.current[refKey];
    if (ref) {
      const cardWidth = ref.querySelector(".car-card")?.offsetWidth || 240;
      const gap = window.innerWidth <= 430 ? 16 : 24;
      ref.scrollBy({ left: (cardWidth + gap) * 4, behavior: "smooth" });
    }
  };

  const handleSlideLeft = (groupKey, viewType = "web") => {
    const refKey = `${viewType}-${groupKey}`;
    const ref = carGridRefs.current[refKey];
    if (ref) {
      const cardWidth = ref.querySelector(".car-card")?.offsetWidth || 240;
      const gap = window.innerWidth <= 430 ? 16 : 24;
      ref.scrollBy({ left: -(cardWidth + gap) * 4, behavior: "smooth" });
    }
  };

  return (
    <div className="my-cars">
      <div className="content-wrapper">
        <div className="main-content">
          <div className="web-view">
            {(loading || actionLoading) && <Loading />}
            {error && <div className="error">{error}</div>}
            {shareError && <div className="error">{shareError}</div>}

            {Object.keys(groupedNew).length === 0 &&
            Object.keys(groupedRequested).length === 0 &&
            Object.keys(groupedApproved).length === 0 ? (
              <div className="no-results">
                <h3>No cars found</h3>
                <p>You haven't added any cars yet.</p>
                <Button
                  className="see-more"
                  variant="primary"
                  onClick={handleSeeMoreCars}
                >
                  Back to Home
                </Button>
              </div>
            ) : (
              <>
                {/* NEW CARS */}
                {Object.entries(groupedNew).map(([yard, cars]) => {
                  const carCount = cars.length;
                  const firstFour = cars.slice(0, 4);
                  const rest = cars.slice(4);
                  const dummyCount =
                    firstFour.length < 4 ? 4 - firstFour.length : 0;
                  const dummies = Array(dummyCount)
                    .fill()
                    .map((_, i) => ({
                      id: `dummy-${yard}-${i}`,
                      isDummy: true,
                      image: dummyImg,
                    }));
                  const displayCars = [...firstFour, ...dummies, ...rest];

                  return (
                    <div className="card-slider" key={yard}>
                      <div className="yard-group">
                        <div className="car-grid-wrapper">
                          <div
                            className="car-grid"
                            ref={(el) =>
                              (carGridRefs.current[`web-${yard}`] = el)
                            }
                          >
                            {displayCars.map((car, idx) => (
                              <CarCard
                                key={car.id}
                                car={car}
                                onCarSelect={handleCarSelect}
                                onRemove={handleRemove}
                                onSlideRight={() =>
                                  handleSlideRight(yard, "web")
                                }
                                onSlideLeft={() => handleSlideLeft(yard, "web")}
                                isFourth={idx === 3}
                                hasMoreCars={displayCars.length > 4}
                                index={idx}
                                disabled={actionLoading}
                              />
                            ))}
                          </div>
                          <LocationCard
                            yard={yard}
                            yardCars={cars}
                            onRequestGatePass={() =>
                              handleRequestGatePass(yard)
                            }
                            onClickToCall={handleClickToCall}
                            carCount={carCount}
                            onShareEvaluationLink={() =>
                              handleShareEvaluationLink(cars, yard)
                            }
                            isActionLoading={actionLoading}
                            isShared={sharedYards.includes(yard)}
                            yardMap={yardMapData[yard]} // Dynamic map
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* REQUESTED */}
                {Object.entries(groupedRequested).map(([yard, cars]) => {
                  const carCount = cars.length;
                  const firstFour = cars.slice(0, 4);
                  const rest = cars.slice(4);
                  const dummyCount =
                    firstFour.length < 4 ? 4 - firstFour.length : 0;
                  const dummies = Array(dummyCount)
                    .fill()
                    .map((_, i) => ({
                      id: `dummy-req-${yard}-${i}`,
                      isDummy: true,
                      image: dummyImg,
                    }));
                  const displayCars = [...firstFour, ...dummies, ...rest];

                  return (
                    <div
                      className="card-slider card-slider-bordered"
                      key={`req-${yard}`}
                    >
                      <div className="yard-group">
                        <div className="car-grid-wrapper">
                          <div
                            className="car-grid"
                            ref={(el) =>
                              (carGridRefs.current[`web-req-${yard}`] = el)
                            }
                          >
                            {displayCars.map((car, idx) => (
                              <CarCard
                                key={car.id}
                                car={car}
                                onCarSelect={handleCarSelect}
                                onRemove={handleRemove}
                                onSlideRight={() =>
                                  handleSlideRight(`req-${yard}`, "web")
                                }
                                onSlideLeft={() =>
                                  handleSlideLeft(`req-${yard}`, "web")
                                }
                                isFourth={idx === 3}
                                hasMoreCars={displayCars.length > 4}
                                index={idx}
                                disabled={actionLoading}
                              />
                            ))}
                          </div>
                          <LocationCard
                            yard={yard}
                            yardCars={cars}
                            onRequestGatePass={() => {}}
                            onClickToCall={handleClickToCall}
                            carCount={carCount}
                            isPendingGroup={true}
                            onShareEvaluationLink={() =>
                              handleShareEvaluationLink(cars, yard)
                            }
                            isActionLoading={actionLoading}
                            isShared={sharedYards.includes(yard)}
                            yardMap={yardMapData[yard]}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* APPROVED */}
                {Object.entries(groupedApproved).map(([yard, cars]) => {
                  const carCount = cars.length;
                  const firstFour = cars.slice(0, 4);
                  const rest = cars.slice(4);
                  const dummyCount =
                    firstFour.length < 4 ? 4 - firstFour.length : 0;
                  const dummies = Array(dummyCount)
                    .fill()
                    .map((_, i) => ({
                      id: `dummy-app-${yard}-${i}`,
                      isDummy: true,
                      image: dummyImg,
                    }));
                  const displayCars = [...firstFour, ...dummies, ...rest];

                  return (
                    <div
                      className="card-slider card-slider-bordered"
                      key={`app-${yard}`}
                    >
                      <div className="yard-group">
                        <div className="car-grid-wrapper">
                          <div
                            className="car-grid"
                            ref={(el) =>
                              (carGridRefs.current[`web-app-${yard}`] = el)
                            }
                          >
                            {displayCars.map((car, idx) => (
                              <CarCard
                                key={car.id}
                                car={car}
                                onCarSelect={handleCarSelect}
                                onRemove={handleRemove}
                                onSlideRight={() =>
                                  handleSlideRight(`app-${yard}`, "web")
                                }
                                onSlideLeft={() =>
                                  handleSlideLeft(`app-${yard}`, "web")
                                }
                                isFourth={idx === 3}
                                hasMoreCars={displayCars.length > 4}
                                index={idx}
                                disabled={actionLoading}
                              />
                            ))}
                          </div>
                          <LocationCard
                            yard={yard}
                            yardCars={cars}
                            onRequestGatePass={() => {}}
                            onClickToCall={handleClickToCall}
                            carCount={carCount}
                            isApprovedGroup={true}
                            onShareEvaluationLink={() =>
                              handleShareEvaluationLink(cars, yard)
                            }
                            isActionLoading={actionLoading}
                            isShared={sharedYards.includes(yard)}
                            yardMap={yardMapData[yard]}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>

          {/* Mobile View */}
          <div className="mobile-view">
            {(loading || actionLoading) && <Loading />}
            {error && <div className="error">{error}</div>}
            {shareError && <div className="error">{shareError}</div>}

            {Object.keys(groupedNew).length === 0 &&
            Object.keys(groupedRequested).length === 0 &&
            Object.keys(groupedApproved).length === 0 ? (
              <div className="no-results">
                <h3>No cars found</h3>
                <p>You haven't added any cars yet.</p>
                <Button
                  className="see-more"
                  variant="primary"
                  onClick={handleSeeMoreCars}
                >
                  Back to Home
                </Button>
              </div>
            ) : (
              <>
                {/* Mobile: New Cars */}
                {Object.entries(groupedNew).map(([yard, cars]) => {
                  const carCount = cars.length;
                  const firstFour = cars.slice(0, 4);
                  const rest = cars.slice(4);
                  const dummyCount =
                    firstFour.length < 4 ? 4 - firstFour.length : 0;
                  const dummies = Array(dummyCount)
                    .fill()
                    .map((_, i) => ({
                      id: `dummy-${yard}-${i}`,
                      isDummy: true,
                      image: dummyImg,
                    }));
                  const displayCars = [...firstFour, ...dummies, ...rest];

                  return (
                    <div className="card-slider" key={yard}>
                      <div className="yard-group">
                        <div className="car-grid-wrapper">
                          <div className="car-card location-card">
                            <div className="location-column">
                              <div className="car-count-heading">
                                <div className="location-heading">
                                  <img
                                    src={locCard}
                                    alt="Location"
                                    className="location-img"
                                  />
                                  <p className="location-title">
                                    {cars[0]?.location || yard}
                                  </p>
                                  <div className="car-img-heading">
                                    <ImageWithFallback
                                      src={smallcar}
                                      alt="Car Icon"
                                      className="small-car-icon"
                                    />
                                    <span className="car-count">
                                      {" "}
                                      {carCount}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="car-grid"
                              ref={(el) =>
                                (carGridRefs.current[`mobile-${yard}`] = el)
                              }
                            >
                              {/* Dynamic Map */}
                              <div
                                className="container-map"
                                onClick={() =>
                                  window.open(
                                    getMapUrl(yardMapData[yard]),
                                    "_blank"
                                  )
                                }
                              >
                                <div
                                  className="yard-map-container"
                                  style={{ pointerEvents: "none" }}
                                  dangerouslySetInnerHTML={{
                                    __html:
                                     buildCleanMapIframe(yardMapData[yard])  ||
                                      '<div style="background:#f0f0f0; height:180px; display:flex; align-items:center; justify-content:center; color:#999; font-size:14px; border-radius:8px;">Map not available</div>',
                                  }}
                                />
                              </div>
                              {displayCars.map((car, idx) => (
                                <CarCard
                                  key={car.id}
                                  car={car}
                                  onCarSelect={handleCarSelect}
                                  onRemove={handleRemove}
                                  onSlideRight={() =>
                                    handleSlideRight(yard, "mobile")
                                  }
                                  onSlideLeft={() =>
                                    handleSlideLeft(yard, "mobile")
                                  }
                                  isFourth={idx === 3}
                                  hasMoreCars={displayCars.length > 4}
                                  disabled={actionLoading}
                                />
                              ))}
                            </div>
                            <div className="buttons">
                              <Button
                                className="btn-full-pass"
                                variant="primary"
                                onClick={() => handleRequestGatePass(yard)}
                                disabled={actionLoading}
                              >
                                {actionLoading
                                  ? "Requesting..."
                                  : "Request Gate Pass"}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* Mobile: Requested */}
                {Object.entries(groupedRequested).map(([yard, cars]) => {
                  const carCount = cars.length;
                  const firstFour = cars.slice(0, 4);
                  const rest = cars.slice(4);
                  const dummyCount =
                    firstFour.length < 4 ? 4 - firstFour.length : 0;
                  const dummies = Array(dummyCount)
                    .fill()
                    .map((_, i) => ({
                      id: `dummy-req-${yard}-${i}`,
                      isDummy: true,
                      image: dummyImg,
                    }));
                  const displayCars = [...firstFour, ...dummies, ...rest];

                  return (
                    <div
                      className="card-slider card-slider-bordered"
                      key={`req-${yard}`}
                    >
                      <div className="yard-group">
                        <div className="car-grid-wrapper">
                          <div className="car-card location-card">
                            <div className="location-column">
                              <div className="car-count-heading">
                                <div className="location-heading">
                                  <img
                                    src={locCard}
                                    alt="Location"
                                    className="location-img"
                                  />
                                  <p className="location-title">
                                    {cars[0]?.location || yard}
                                  </p>
                                  <div className="car-img-heading">
                                    <ImageWithFallback
                                      src={smallcar}
                                      alt="Car Icon"
                                      className="small-car-icon"
                                    />
                                    <span className="car-count">
                                      {" "}
                                      {carCount}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="car-grid"
                              ref={(el) =>
                                (carGridRefs.current[`mobile-req-${yard}`] = el)
                              }
                            >
                               <div
                                className="container-map"
                                onClick={() =>
                                  window.open(
                                    getMapUrl(yardMapData[yard]),
                                    "_blank"
                                  )
                                }
                              >
                                <div
                                  className="yard-map-container"
                                  style={{ pointerEvents: "none" }}
                                  dangerouslySetInnerHTML={{
                                    __html:
                                    buildCleanMapIframe(yardMapData[yard])||
                                      '<div style="background:#f0f0f0; height:180px; display:flex; align-items:center; justify-content:center; color:#999; font-size:14px; border-radius:8px;">Map not available</div>',
                                  }}
                                />
                              </div>
                              {displayCars.map((car, idx) => (
                                <CarCard
                                  key={car.id}
                                  car={car}
                                  onCarSelect={handleCarSelect}
                                  onRemove={handleRemove}
                                  onSlideRight={() =>
                                    handleSlideRight(`req-${yard}`, "mobile")
                                  }
                                  onSlideLeft={() =>
                                    handleSlideLeft(`req-${yard}`, "mobile")
                                  }
                                  isFourth={idx === 3}
                                  hasMoreCars={displayCars.length > 4}
                                  disabled={actionLoading}
                                />
                              ))}
                            </div>
                            <div className="buttons">
                              <Button
                                className="btn-full-pending"
                                variant="primary"
                                disabled
                              >
                                Pending Gate Pass
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* Mobile: Approved */}
                {Object.entries(groupedApproved).map(([yard, cars]) => {
                  const carCount = cars.length;
                  const firstFour = cars.slice(0, 4);
                  const rest = cars.slice(4);
                  const dummyCount =
                    firstFour.length < 4 ? 4 - firstFour.length : 0;
                  const dummies = Array(dummyCount)
                    .fill()
                    .map((_, i) => ({
                      id: `dummy-app-${yard}-${i}`,
                      isDummy: true,
                      image: dummyImg,
                    }));
                  const displayCars = [...firstFour, ...dummies, ...rest];

                  return (
                    <div
                      className="card-slider card-slider-bordered"
                      key={`app-${yard}`}
                    >
                      <div className="yard-group">
                        <div className="car-grid-wrapper">
                          <div className="car-card location-card">
                            <div className="location-column">
                              <div className="car-count-heading">
                                <div className="location-heading">
                                  <img
                                    src={locCard}
                                    alt="Location"
                                    className="location-img"
                                  />
                                  <p className="location-title">
                                    {cars[0]?.location || yard}
                                  </p>
                                  <div className="car-img-heading">
                                    <ImageWithFallback
                                      src={smallcar}
                                      alt="Car Icon"
                                      className="small-car-icon"
                                    />
                                    <span className="car-count">
                                      {" "}
                                      {carCount}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="car-grid"
                              ref={(el) =>
                                (carGridRefs.current[`mobile-app-${yard}`] = el)
                              }
                            >
                                <div
                                className="container-map"
                                onClick={() =>
                                  window.open(
                                    getMapUrl(yardMapData[yard]),
                                    "_blank"
                                  )
                                }
                              >
                                <div
                                  className="yard-map-container"
                                  style={{ pointerEvents: "none" }}
                                  dangerouslySetInnerHTML={{
                                    __html:
                                    buildCleanMapIframe(yardMapData[yard]) ||
                                      '<div style="background:#f0f0f0; height:180px; display:flex; align-items:center; justify-content:center; color:#999; font-size:14px; border-radius:8px;">Map not available</div>',
                                  }}
                                />
                              </div>
                              {displayCars.map((car, idx) => (
                                <CarCard
                                  key={car.id}
                                  car={car}
                                  onCarSelect={handleCarSelect}
                                  onRemove={handleRemove}
                                  onSlideRight={() =>
                                    handleSlideRight(`app-${yard}`, "mobile")
                                  }
                                  onSlideLeft={() =>
                                    handleSlideLeft(`app-${yard}`, "mobile")
                                  }
                                  isFourth={idx === 3}
                                  hasMoreCars={displayCars.length > 4}
                                  disabled={actionLoading}
                                />
                              ))}
                            </div>
                            <div className="buttons">
                              <Button
                                className="btn-full-pass"
                                variant="primary"
                                onClick={() =>
                                  handleShareEvaluationLink(cars, yard)
                                }
                                disabled={
                                  actionLoading || sharedYards.includes(yard)
                                }
                              >
                                {actionLoading
                                  ? "Sharing..."
                                  : "Share Evaluation Link"}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>

     <GatePassModal
  isOpen={isGatePassModalOpen}
  onClose={handleCloseGatePassModal}
  yard={selectedYard || "Unknown Yard"}
  onChooseEvaluator={handleChooseEvaluator}
  onAddEvaluator={handleAddEvaluator}
  cars={groupedNew[selectedYard] || []}
  onDriverAdded={driverAdded}
  onGatePassCreated={handleGatePassCreated}
  yardMap={yardMapData[selectedYard]}
  buildCleanMapIframe={buildCleanMapIframe}
  getMapUrl={getMapUrl}
/>
      <AddEvaluatorModal
        isOpen={isAddEvaluatorModalOpen}
        onClose={handleCloseAddEvaluatorModal}
        onDriverAdded={handleDriverAdded}
      />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
}
